import styled, { type CSSProperties } from 'styled-components'

import { helpers } from 'styles'

type Props = {
	textAlign?: CSSProperties['textAlign']
}

export const ContentPadded = styled.div<Props>`
	color: ${helpers.color.text};
	font-size: ${helpers.font.size.base};
	padding: 0 16px;
	text-align: ${({ textAlign = 'left' }) => textAlign};
`
